import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { FaDownload, FaTimes } from 'react-icons/fa';
import usePwaInstall from '../hooks/usePwaInstall';

// Pasos para instalar a mano, cuando el navegador no ofrece su cuadro de
// instalación (iOS nunca lo ofrece; Chrome solo tras algo de uso de la página).
const PASOS = {
  ios: [
    <>Abre Vendita en <strong>Safari</strong>.</>,
    <>Toca el botón <strong>Compartir</strong> (el cuadro con la flecha hacia arriba).</>,
    <>Elige <strong>Agregar a inicio</strong> y confirma.</>,
  ],
  android: [
    <>Abre Vendita en <strong>Chrome</strong>.</>,
    <>Toca el menú <strong>⋮</strong> (arriba a la derecha).</>,
    <>Elige <strong>Instalar app</strong> o <strong>Agregar a la pantalla principal</strong> y confirma.</>,
  ],
  escritorio: [
    <>Abre Vendita en <strong>Chrome</strong> o <strong>Edge</strong>.</>,
    <>Haz clic en el ícono de instalar, a la derecha de la barra de direcciones, o abre el menú <strong>⋮</strong>.</>,
    <>Elige <strong>Instalar Vendita</strong> y confirma.</>,
  ],
};

// Botón "Instalar app" del menú lateral. Si el navegador permite instalar,
// abre su cuadro de instalación; si no, muestra los pasos para hacerlo desde
// el menú del navegador. Con la app ya instalada no se muestra.
const InstallAppButton = ({ collapsed, className = '' }) => {
  const { instalada, puedeInstalar, plataforma, instalar } = usePwaInstall();
  const [verPasos, setVerPasos] = useState(false);

  if (instalada) return null;

  const onClick = () => (puedeInstalar ? instalar() : setVerPasos(true));

  return (
    <>
      <button
        type="button"
        onClick={onClick}
        title="Instalar Vendita como app"
        className={`w-full flex items-center ${collapsed ? 'justify-center' : 'gap-3'} px-4 py-2.5 rounded-xl bg-emerald-500/10 text-emerald-400 hover:bg-emerald-500/20 font-bold text-sm transition-all ${className}`}
      >
        <FaDownload className="flex-shrink-0" />
        {!collapsed && <span className="whitespace-nowrap">Instalar app</span>}
      </button>

      {/* Portal: el menú lateral usa transform, que atraparía un position: fixed. */}
      {verPasos &&
        createPortal(
          <div
            className="fixed inset-0 z-[100] bg-black/60 flex items-end sm:items-center justify-center p-4"
            onClick={() => setVerPasos(false)}
          >
            <div
              role="dialog"
              aria-label="Instalar Vendita"
              className="bg-white rounded-2xl p-6 w-full max-w-sm shadow-2xl text-gray-800"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-start mb-4">
                <h2 className="text-lg font-black">Instalar Vendita</h2>
                <button type="button" onClick={() => setVerPasos(false)} aria-label="Cerrar" className="text-gray-400 hover:text-gray-700">
                  <FaTimes />
                </button>
              </div>
              <ol className="list-decimal list-inside space-y-2 text-sm">
                {PASOS[plataforma].map((paso, i) => (
                  <li key={i}>{paso}</li>
                ))}
              </ol>
              <p className="text-xs text-gray-500 mt-4">
                Vendita quedará con su ícono en la pantalla de inicio. Si ya la instalaste, ábrela desde ese ícono.
              </p>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default InstallAppButton;
